import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class SmallSignalAndRFDiodeAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVr = 100;
		this.normIf = 10;
		this.normIr = 800000;

		this.rankVr = 0;
		this.rankIf = 0;
		this.rankIr = 0;

		this.weightVr = 0.18;
		this.weightIf = 0.16;
		this.weightIr = 0.16;

		this.rVr = 0;
		this.rIf = 0;
		this.rIr = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_Vr,rVr,rankVr,part_If,rIf,rankIf,part_Ir,rIr,rankIr,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Reverse voltage  VR Min (V)---------------------------------------------

		[this.rankVr, this.rVr] = this.calculateRankSingleSliderGTE(CIDS.REVERSE_VOLTAGE_MIN, product, this.normVr);

		// ---------------------------------------------Forward current  IF Max (A)---------------------------------------------

		[this.rankIf, this.rIf] = this.calculateRankSingleSliderGTE(CIDS.FORWARD_CURRENT_MAX, product, this.normIf);

		// ---------------------------------------------Reverse current  IR Max (µA)---------------------------------------------

		[this.rankIr, this.rIr] = this.calculateRankSingleSliderGTE(CIDS.REVERSE_CURRENT_MAX, product, this.normIr);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightVr * this.rankVr + this.weightIf * this.rankIf + this.weightIr * this.rankIr;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVr - this.weightIf - this.weightIr) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
